// The #N on each item counts up from the oldest scan, so it needs the size of
// the whole box -- which, with the box streamed in pages, is only known once the
// last page lands. The first page is now small (50), so without help the top
// item would read #50 and then jump to the real number.
//
// After every complete load we remember the total and the newest scan's id.
// Next time, if the first page's newest scan is the same one, nothing has been
// added since and the cached total is right from the first frame. If there is
// a newer scan, the cache is stale and the numbers stay hidden until the load
// completes rather than show wrong ones.
//
// Kept in localStorage, per user: it is a display hint only, so a blocked or
// cleared store just means no numbers until the load finishes.
const key = (username) => `og:box-count:${username}`;

export function readBoxCount(username) {
  try {
    const value = JSON.parse(localStorage.getItem(key(username)));
    if (
      value &&
      Number.isInteger(value.total) &&
      typeof value.newestId === 'string'
    ) {
      return value;
    }
  } catch (e) {
    // Malformed entry or storage unavailable: behave as if nothing is cached.
  }
  return null;
}

export function writeBoxCount(username, total, newestId) {
  try {
    localStorage.setItem(key(username), JSON.stringify({ total, newestId }));
  } catch (e) {
    // Storage unavailable: the numbers just wait for the next full load.
  }
}

// The number to show for the item at index i, or null for none yet.
export function itemNumber(i, { listLength, streaming, expectedTotal, filtered }) {
  if (filtered || !streaming) return listLength - i;
  return expectedTotal == null ? null : expectedTotal - i;
}
